import React, { useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { Menu } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const API_BASE = "https://neoliv-backend-otp.vercel.app";

const HorizontalForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    source: "source",
    subsource: "subsource",
    countryCode: "+91",
    country: "India",
    configuration: "",
    url: window.location.href,
    refererUrl: document.referrer,
    whatsappOptIn: true,
  });

  const [otp, setOtp] = useState("");
  const [verifyId, setVerifyId] = useState("");
  const [showOtpField, setShowOtpField] = useState(false);
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [isSendingOtp, setIsSendingOtp] = useState(false);
  const [isVerifyingOtp, setIsVerifyingOtp] = useState(false);

  const [selectedLocation, setSelectedLocation] = useState("");
  const [selectedProject, setSelectedProject] = useState("");
  const [dropdownStep, setDropdownStep] = useState("location");

  const projectData = {
    NCR: ["NeoLiv Grand Park"],
    Mumbai: ["Neoliv Grand Forest Prive"],
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleCheckboxChange = (e) => {
    setFormData({ ...formData, whatsappOptIn: e.target.checked });
  };

  const handleLocationSelect = (city) => {
    setSelectedLocation(city.trim());
    setSelectedProject("");
    setFormData({
      ...formData,
      city: city.trim(),
      configuration: "",
    });
    setDropdownStep("project");
  };

  const handleProjectSelect = (project) => {
    setSelectedProject(project.trim());
    setFormData({
      ...formData,
      configuration: project.trim(),
    });
  };

  const handleOtpSend = async () => {
    if (!formData.name.trim()) return toast.error("Enter your name");
    if (!formData.email.trim()) return toast.error("Enter your email");
    if (!formData.mobile.trim()) return toast.error("Enter mobile number");
    if (!selectedLocation.trim())
      return toast.error("Select project location");
    if (!formData.configuration.trim())
      return toast.error("Select configuration");

    setIsSendingOtp(true);
    try {
      const response = await fetch(`${API_BASE}/api/send-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ mobile: formData.mobile }),
      });

      const responseData = await response.json();
      if (!response.ok) throw new Error("OTP failed");

      toast.success("OTP sent successfully!");
      setVerifyId(responseData.verifyId);
      setShowOtpField(true);
      setIsOtpSent(true);
    } catch {
      toast.error("OTP send error");
    }
    setIsSendingOtp(false);
  };

  const handleOtpVerify = async () => {
    if (!otp.trim()) return toast.error("Enter OTP");

    setIsVerifyingOtp(true);
    try {
      const response = await fetch(`${API_BASE}/api/verify-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ verifyId, otp }),
      });

      const result = await response.json();

      if (result.status === "VERIFIED") {
        toast.success("OTP Verified!");
        setIsOtpVerified(true);
        handleSubmitLead();
      } else {
        toast.error("Invalid OTP");
      }
    } catch {
      toast.error("OTP verification error");
    }

    setIsVerifyingOtp(false);
  };

  const handleSubmitLead = async () => {
    try {
      const dataToSubmit = {
        ...formData,
        city: selectedLocation.trim(),
        configuration: formData.configuration.trim(),
      };

      const response = await fetch(`${API_BASE}/api/create-lead`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(dataToSubmit),
      });

      if (response.ok) {
        toast.success("Lead Submitted Successfully!");

        setFormData({
          name: "",
          email: "",
          mobile: "",
          configuration: "",
          whatsappOptIn: true,
          source: "source",
          subsource: "subsource",
          countryCode: "+91",
          country: "India",
          url: window.location.href,
          refererUrl: document.referrer,
        });

        setOtp("");
        setSelectedLocation("");
        setSelectedProject("");
        setDropdownStep("location");
        setIsOtpSent(false);
        setIsOtpVerified(false);
        setShowOtpField(false);
      }
    } catch {
      toast.error("Submit error");
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-gradient-to-b from-blue-950 to-indigo-950 p-6"
      id="contact-form"
    >
      <form
        className="w-full max-w-5xl bg-white/10 backdrop-blur-3xl border border-white/20 rounded-3xl shadow-2xl p-12 grid grid-cols-1 md:grid-cols-2 gap-8"
        onSubmit={(e) => e.preventDefault()}
      >
        {/* LEFT */}
        <div className="flex flex-col gap-6">
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Name"
            className="px-5 py-2 rounded-2xl bg-white/20 text-white placeholder-white/70 shadow-inner focus:ring-2 focus:ring-white outline-none"
          />

          

          <PhoneInput
            country={"in"}
            value={formData.mobile}
            onChange={(value) =>
              setFormData({ ...formData, mobile: value })
            }
            inputStyle={{
              width: "100%",
              borderRadius: "12px",
              border: "none",
              padding: "25px",
              paddingLeft: "3rem",
              background: "rgba(255,255,255,0.2)",
              color: "white",
            }}
          />
        </div>

        {/* RIGHT */}
        <div className="flex flex-col gap-6">
<input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Email ID"
            className="px-5 py-2 rounded-2xl bg-white/20 text-white placeholder-white/70 shadow-inner focus:ring-2 focus:ring-white outline-none"
          />
{/* Single Configuration Dropdown */}
<Menu as="div" className="relative w-full">
  <>
    <Menu.Button className="w-full flex justify-between items-center px-5 py-2 rounded-xl bg-white/20 text-white shadow-inner">
      {selectedProject
        ? selectedProject
        : selectedLocation
        ? `Choose Project (${selectedLocation})`
        : "Select Configuration"}
      <ChevronDownIcon className="w-5 h-5 text-white/70" />
    </Menu.Button>

    <Menu.Items className="absolute mt-2 w-full bg-white rounded-xl shadow-lg z-20 overflow-hidden">

      {/* ===== LOCATION STEP ===== */}
      {!selectedLocation && (
        <>
          <div className="px-4 py-2 text-xs font-semibold text-gray-500 bg-gray-50">
            Choose Location
          </div>

          {["NCR", "Mumbai"].map((city) => (
            <div
              key={city}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setSelectedLocation(city);
                setSelectedProject("");
                setFormData({
                  ...formData,
                  city: city,
                  configuration: "",
                });
              }}
              className="px-4 py-3 cursor-pointer hover:bg-gray-100"
            >
              {city}
            </div>
          ))}
        </>
      )}

      {/* ===== PROJECT STEP ===== */}
      {selectedLocation && (
        <>
          {/* Change Location Option */}
          <div
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setSelectedLocation("");
              setSelectedProject("");
              setFormData({
                ...formData,
                city: "",
                configuration: "",
              });
            }}
            className="px-4 py-3 cursor-pointer text-blue-600 font-semibold hover:bg-gray-100 border-b"
          >
            ← Change Location
          </div>

          <div className="px-4 py-2 text-xs font-semibold text-gray-500 bg-gray-50">
            Choose Project ({selectedLocation})
          </div>

          {projectData[selectedLocation]?.map((proj) => (
            <Menu.Item key={proj}>
              {({ active }) => (
                <button
                  type="button"
                  onClick={() => {
                    setSelectedProject(proj);
                    setFormData({
                      ...formData,
                      configuration: proj,
                    });
                  }}
                  className={`w-full px-4 py-3 text-left ${
                    active ? "bg-gray-100" : ""
                  }`}
                >
                  {proj}
                </button>
              )}
            </Menu.Item>
          ))}
        </>
      )}
    </Menu.Items>
  </>
</Menu>
          {/* WhatsApp */}
          <div className="flex items-center gap-2 text-white text-sm">
            <input
              type="checkbox"
              checked={formData.whatsappOptIn}
              onChange={handleCheckboxChange}
            />
            Opt for WhatsApp notifications
          </div>
        </div>

        {/* BUTTONS */}
        <div className="md:col-span-2 mx-auto flex flex-col gap-4 mt-2">
          {!isOtpSent && (
            <button
              type="button"
              onClick={handleOtpSend}
              disabled={isSendingOtp}
              className="w-fit py-3 px-7 bg_blue_950 rounded-3xl text-white border border-white font-bold text-md shadow-lg hover:scale-105 transition-transform"
            >
              {isSendingOtp ? "Sending OTP..." : "Send OTP"}
            </button>
          )}

          {isOtpSent && showOtpField && !isOtpVerified && (
            <>
              <input
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                placeholder="Enter OTP"
                className="w-full px-5 py-3 rounded-2xl bg-white/20 text-white shadow-inner outline-none"
              />
              <button
                type="button"
                onClick={handleOtpVerify}
                className="w-full py-4 bg-green-500 rounded-3xl text-white font-bold text-lg shadow-lg hover:bg-green-600 transition"
              >
                {isVerifyingOtp ? "Verifying..." : "Verify OTP"}
              </button>
            </>
          )}
        </div>
      </form>

      <ToastContainer />
    </div>
  );
};

export default HorizontalForm;